import { Search } from "lucide-react";

export const SearchBar = ({ filters, institutional = false, onApply, onFiltersChange, onReset, options, insightPills = [], testIdPrefix = "listing-search" }) => {
  const handleChange = (event) => {
    const { name, value } = event.target;
    onFiltersChange({ ...filters, [name]: value });
  };

  return (
    <div className={`agent-portal-search rounded-[28px] p-4 shadow-[0_24px_70px_rgba(0,25,53,0.08)] md:p-5 ${institutional ? "border border-[#D7C39A]/45 bg-[linear-gradient(180deg,#F3E8D4_0%,#E9DCC4_100%)]" : "border border-[#001935]/10 bg-[#fffaf1]/95"}`} data-testid={`${testIdPrefix}-container`}>
      <div className="grid gap-3 md:grid-cols-[1.1fr_1fr_1fr_auto_auto]">
        <select className={institutional ? "w-full rounded-2xl border border-[#D7C39A]/45 bg-[#FFFDF7] px-4 py-3 text-sm text-[#0C285A] outline-none transition duration-300 focus:border-[#B8860B] focus:ring-2 focus:ring-[#B8860B]/18" : "field-shell"} data-testid={`${testIdPrefix}-district-select`} name="district" onChange={handleChange} value={filters.district}>
          <option value="">All Districts</option>
          {options.districts.map((district) => (
            <option key={district} value={district}>
              {district}
            </option>
          ))}
        </select>

        <select className={institutional ? "w-full rounded-2xl border border-[#D7C39A]/45 bg-[#FFFDF7] px-4 py-3 text-sm text-[#0C285A] outline-none transition duration-300 focus:border-[#B8860B] focus:ring-2 focus:ring-[#B8860B]/18" : "field-shell"} data-testid={`${testIdPrefix}-tenure-select`} name="tenure" onChange={handleChange} value={filters.tenure}>
          <option value="">Any Tenure</option>
          {options.tenures.map((tenure) => (
            <option key={tenure} value={tenure}>
              {tenure}
            </option>
          ))}
        </select>

        <select className={institutional ? "w-full rounded-2xl border border-[#D7C39A]/45 bg-[#FFFDF7] px-4 py-3 text-sm text-[#0C285A] outline-none transition duration-300 focus:border-[#B8860B] focus:ring-2 focus:ring-[#B8860B]/18" : "field-shell"} data-testid={`${testIdPrefix}-property-type-select`} name="property_type" onChange={handleChange} value={filters.property_type}>
          <option value="">All Property Types</option>
          {options.property_types.map((type) => (
            <option key={type} value={type}>
              {type}
            </option>
          ))}
        </select>

        <button className="gold-button w-full md:w-auto" data-testid={`${testIdPrefix}-submit-button`} onClick={onApply} type="button">
          <Search className="mr-2 h-4 w-4" /> Search
        </button>
        <button className={`w-full md:w-auto ${institutional ? "inline-flex items-center justify-center rounded-full border border-[#B8860B]/55 bg-transparent px-5 py-3 text-sm font-semibold text-[#B8860B] transition duration-300 hover:-translate-y-0.5 hover:bg-[#FFF4DB]" : "outline-button"}`} data-testid={`${testIdPrefix}-reset-button`} onClick={onReset} type="button">
          Reset
        </button>
      </div>
      {insightPills.length ? (
        <div className="mt-4 flex flex-wrap gap-2" data-testid={`${testIdPrefix}-insight-pills`}>
          {insightPills.map((pill) => (
            <div className={`rounded-full border px-4 py-2 text-[11px] font-bold uppercase tracking-[0.16em] ${institutional ? "border-[#B8860B]/28 bg-[#FFF4DB] text-[#B8860B]" : "border-[#D4AF37]/30 bg-white text-[#8b6d16]"}`} data-testid={`${testIdPrefix}-insight-pill-${pill.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} key={pill.label}>
              {pill.label}: {pill.value}
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
};